module.exports = __webpack_public_path__ + "static/k-quick-menu-d977bc377a9d7981884888111c469adb.jpg";